import Vue from 'vue'
import VueRouter from 'vue-router'
import Entry from '@/views/Entry/index.vue'

Vue.use(VueRouter)

// Vue-Router在3.1.0版本里面新增功能：push和replace方法会返回一个promise, 你可能在控制台看到未捕获的异常。这里统一处理
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => err)
}

import Home from '@views/display-module/home'
const webRoutes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/display-module/home'),
    meta: {
      title: '光阳蛋业'
    }
  },
  {
    path: '/product-system',
    name: 'ProductSystem',
    component: () => import('@/views/display-module/product-system')
  },
  {
    path: '/group-members',
    name: 'GroupMembers',
    component: () => import('@/views/display-module/group-members')
  },
  {
    path: '/dev-history',
    name: 'DevHistory',
    component: () => import('@/views/display-module/dev-history')
  },
  {
    path: '/online-mall',
    name: 'OnlineMall',
    component: () => import('@/views/display-module/online-mall')
  },
  {
    path: '/enterprise-news',
    name: 'EnterpriseNews',
    component: () => import('@/views/display-module/enterprise-news')
  },
  {
    path: '/history-media',
    name: 'HistoryMedia',
    component: () => import('@/views/display-module/history-media')
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: () => import('@/views/display-module/contact-us')
  }
]

// 移动端路由配置
const mobileRoutes = [
  {
    path: '/',
    name: 'MobileHome',
    component: () => import('@/views/mobile/home/index.vue'),
    meta: {
      title: '光阳蛋业'
    }
  },
  {
    path: '/product-system',
    name: 'MobileProductSystem',
    component: () => import('@/views/mobile/product-system/index.vue')
  },
  {
    path: '/group-members',
    name: 'MobileGroupMembers',
    component: () => import('@/views/mobile/group-members/index.vue')
  },
  {
    path: '/dev-history',
    name: 'MobileDevHistory',
    component: () => import('@/views/mobile/dev-history/index.vue')
  },
  {
    path: '/online-mall',
    name: 'MobileOnlineMall',
    component: () => import('@/views/mobile/online-mall/index.vue')
  },
  {
    path: '/enterprise-news',
    name: 'MobileEnterpriseNews',
    component: () => import('@/views/mobile/enterprise-news/index.vue')
  },
  {
    path: '/history-media',
    name: 'MobileHistoryMedia',
    component: () => import('@/views/mobile/history-media/index.vue')
  },
  {
    path: '/contact-us',
    name: 'MobileContactUs',
    component: () => import('@/views/mobile/contact-us/index.vue')
  }
]
function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  console.log('userAgent', userAgent)

  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return mobileRegex.test(userAgent)
}

// 根据设备类型选择路由配置
const routes = isMobile() ? mobileRoutes : webRoutes
const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
